import React from 'react';
import { saveAs } from 'file-saver';
// @ts-ignore
import styles from "./VCardDownloader.module.css";
// @ts-ignore
import { generateVCard } from '../libs/vcard/exporters/VCard4.ts';
// VCard 3 import kept for potential future use:
 import { generateVCard3 } from '../libs/vcard/exporters/VCard3.ts';

function VCardDownloader({ filename, vCardData }) {
    function downloadVCard4() {
        // Create VCard 4 content from parsed VCard data
        let vCardContent = generateVCard(vCardData);

        // Create a blob from the VCard content
        const blob = new Blob([vCardContent], {type: "text/vcard;charset=utf-8"});

        // Check if filename already has .vcf extension
        let filenameWithExtension = filename.endsWith('.vcf') ? filename : `${filename}.vcf`;

        // Use file-saver to save the file
        saveAs(blob, filenameWithExtension);
    }
    function downloadVCard3Outlook() {
        // Create VCard 3 content optimized for older Outlook
        let vCardContent = generateVCard3(vCardData);

        // Create a blob with UTF-8 encoding
        const blob = new Blob([vCardContent], {type: "text/vcard;charset=utf-8"});

        // Check if filename already has .vcf extension
        let filenameWithExtension = filename.endsWith('.vcf') ? filename : `${filename}.vcf`;

        // Use file-saver to save the file
        saveAs(blob, filenameWithExtension);
    }

    return (
        <div className={styles['button-container']}>
            <button className={styles['download-btn']} onClick={downloadVCard4}>Download VCard</button>
            <button className={`${styles['download-btn']} ${styles['secondary-btn']}`} onClick={downloadVCard3Outlook}>Download VCard for iOS & Outlook</button>
        </div>
    );
}

export default VCardDownloader;